var map = {
	"./Eventxtra Virtual Platform_v8-07.png": 805,
	"./Eventxtra Virtual Platform_v8-08.png": 806,
	"./Eventxtra Virtual Platform_v8-09.png": 807,
	"./Eventxtra Virtual Platform_v8-10.png": 808,
	"./Eventxtra Virtual Platform_v8-11.png": 809,
	"./Eventxtra Virtual Platform_v8-12.png": 810,
	"./Eventxtra Virtual Platform_v8-13.png": 811,
	"./Eventxtra Virtual Platform_v8-14.png": 812,
	"./Eventxtra Virtual Platform_v8-15.png": 813,
	"./Eventxtra Virtual Platform_v8-16.png": 814,
	"./Eventxtra Virtual Platform_v8-17.png": 815,
	"./Eventxtra Virtual Platform_v8-18.png": 816,
	"./Eventxtra Virtual Platform_v8-19.png": 817,
	"./Eventxtra Virtual Platform_v8-20.png": 818,
	"./Eventxtra Virtual Platform_v8-21.png": 819,
	"./Eventxtra Virtual Platform_v8-22.png": 820,
	"./banner-01.png": 821,
	"./banner-02.png": 822,
	"./hkstp_logo.png": 823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 186;